import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useHealthlinkPracticeSave = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error saving practice");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const mutation = useMutation({
    mutationFn: async ({ formData, practiceId, password }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/practice?practiceId=${encodeURIComponent(
          practiceId
        )}&password=${encodeURIComponent(password)}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Practice saved");
      queryClient.invalidateQueries({ queryKey: ["healthlinkPractice"] });
      queryClient.invalidateQueries({ queryKey: ["healthMailLoginDetails"] });
    },
    onError: handleNetworkError,
  });

  return mutation;
};
